<template lang="">
  <div class="bbs_filter">
    <div class="lft_area">
      <div class="bbs_info">
        <div class="total"><strong>{{ getCurrentCount() }}</strong> / {{ merchantListCount }}</div>
      </div>
    </div>
    <div class="rgt_area">
      <div class="bbs_srch">
        <select name="" id="" class="i_sel" v-model="searchType">
          <option
            v-for="option in searchOptions"
            :value="option.value"
          >{{ option.name }}</option>
        </select>
        <input type="text" class="i_txt" name="keyword" v-model="searchWord">
        <button type="button" class="bt_base gray btn_srch" @click="getSearch">검색</button>
      </div>
    </div>
  </div>

  <div class="bbs_list">
    <table class="bbs_tbl">
      <colgroup>
        <col style="width:30px">
        <col style="width:90px">
        <col style="width:50px">
        <col style="width:auto">
      </colgroup>
      <thead>
        <tr>
          <th scope="col">번호</th>
          <th scope="col">거래처코드</th>
          <th scope="col">사업자번호</th>
          <th scope="col" width="80px">활성화여부</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(merchant, index) in merchantList"
        >
          <td>{{ merchant.authSeq }}</td>
          <td class="content"><a @click="toMerchant(merchant.authSeq)">{{ merchant.comId }}</a></td>
          <td>{{ merchant.businessNum }}</td>
          <td>{{ merchant.isActive == 'true' ? '활성화' : '비활성화' }}</td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="paginate">
    <AdminPagination
      :totalPages = "totalPages()"
      :currentPage = "currentPage"
      @changePage = "changePage"
    />

    <div class="rgt_area">
      <button type="button" class="bt_base primary large_h" @click="createPartner">거래처 등록</button>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import AdminPagination from '@/components/common/AdminPagination.vue';

const adminMerchantModule = 'adminMerchantModule'

export default {
  components: {
    AdminPagination
  },

  data () {
    return {
      currentPage: 1,
      selectedMerchants: [],

      searchOptions: [
        { name: '전체', value: 'all' },
        { name: '거래처코드', value: 'comId' },
        { name: '사업자번호', value: 'businessNum' },
      ],
      searchType: 'all',
      searchWord: ''
    }
  },
  methods: {
    ...mapActions(adminMerchantModule, [
      'requestMerchantList',
      //'requestDeletePartners',
    ]),

    toMerchant (authSeq) {
      this.$router.push({ 
        name: "MerchantManageEditPage", 
        params: { authSeq: authSeq.toString() } 
      });
    },

    createPartner () {
      this.$router.push({ name: "MerchantManageCreatePage" })
    },

    totalPages() {
      return Math.ceil(this.merchantListCount / 10);
    },

    async changePage(page) {
      this.currentPage = page
      const {currentPage, searchType, searchWord} = this
      await this.requestMerchantList({currentPage, searchType, searchWord})
    },

    getCurrentCount() {
      const currentFirstCount = (this.currentPage - 1) * 10 + 1
      let currentLastCount = this.currentPage * 10
      if (parseInt(currentLastCount) > parseInt(this.merchantListCount)) {
        currentLastCount = this.merchantListCount
      }
      return currentFirstCount + '-' + currentLastCount
    },

    async getSearch() {
      if (this.searchWord === '') {
        alert('검색어를 입력해주세요')
        return
      }
      this.currentPage = 1
      const {currentPage, searchType, searchWord} = this
      await this.requestMerchantList({currentPage, searchType, searchWord})
    }
  },

  computed: {
    ...mapState(adminMerchantModule, [
      'merchantList',
      'merchantListCount'
    ])
  },

  async mounted() {
    const {currentPage, searchType, searchWord} = this
    await this.requestMerchantList({ currentPage, searchType, searchWord })
  }
}
</script>
<style lang="">
    
</style>